export default __webpack_public_path__ + "static/media/ssl_1.5cb767e7.PNG";